import { List, ListItem, ListItemText, Typography } from "@mui/material";
import React from "react";
import { SkillDto } from "../../../types/applicationTypes";
import { itSkillLevels } from "../../../utils/skillLevels";
import ProfileDataCard from "./ProfileDataCard";

interface ItSkillsProps {
  itSkills: SkillDto[];
}

/**
 * This component displays the IT skills of an applicant.
 * @param itSkills The IT skills of an applicant
 * @returns The IT skills of an applicant.
 */
const ItSkills = ({ itSkills }: ItSkillsProps) => {
  /**
   * Maps the level of the IT skill to the corresponding text
   * @param level The level of the IT skill
   * @returns The text of the level
   */
  const mapLevelToText = (level: number) => {
    return itSkillLevels.find((itSkill) => itSkill.level === Number(level))?.label;
  };

  return (
    <ProfileDataCard title="IT-Kenntnisse">
      <List
        disablePadding
        sx={{ listStyleType: "square", listStylePosition: "outside", pl: itSkills.length === 0 ? 0 : 2 }}
      >
        {itSkills.length === 0 ? (
          <Typography>Keine Angaben</Typography>
        ) : (
          itSkills.map((itSkill, index) => {
            return (
              <ListItem key={index} disablePadding sx={{ display: "list-item" }}>
                <ListItemText>
                  {itSkill.name} ({mapLevelToText(itSkill.level)})
                </ListItemText>
              </ListItem>
            );
          })
        )}
      </List>
    </ProfileDataCard>
  );
};

export default ItSkills;
